// extracted by mini-css-extract-plugin
export default {"list":"EarnedAchievements_list__6NOgG","achieveImage":"EarnedAchievements_achieveImage__lekRg"};